export class User {
    ID: string;
    UserName: string;
    Email: string;
    Password: string;
    NewPassword: string;
    RePassword: string;
}